import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ValueStack() {
  return <section id="pricing" className="py-16 md:py-24 px-4 bg-card/50" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <div className="text-center mb-12" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main mb-4" data-id="element-126">
            Esto es lo que vas a recibir hoy mismo:
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="bg-base border border-warm/20 rounded-xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-8 mb-12" data-id="element-127">
          <div className="bg-warm/10 p-6 rounded-full text-warm shrink-0" data-id="element-128">
            <BookOpenIcon size={40} data-id="element-129" />
          </div>
          <div className="flex-1 text-center md:text-left" data-id="element-130">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-main mb-2" data-id="element-131">
              Mente en Calma
            </h3>
            <p className="text-muted text-base md:text-lg leading-relaxed" data-id="element-132">
              El método paso a paso de 7 días que usa la neurociencia y el
              biohacking para enviarle una señal química a tu cerebro de que el
              peligro ha pasado. Sin vueltas. Sin teoría aburrida. Solo
              protocolos que funcionan en 5 minutos o menos.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-b from-base to-card border border-warm/30 rounded-2xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-133">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-warm to-transparent" data-id="element-134"></div>

          <div id="price-zone" className="mb-6" data-id="element-135">
            <p className="text-sm font-bold text-urgent uppercase tracking-widest mb-4" data-id="element-136">
              Oferta por tiempo limitado
            </p>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-137">
              <span className="text-xl md:text-2xl text-muted/60 line-through decoration-2" data-id="element-138">
                ARS 45.000
              </span>
              <span className="bg-[#F25C05] text-white text-xs md:text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-139">
                70% OFF
              </span>
            </div>
            <h3 className="text-5xl md:text-6xl font-serif font-bold text-warm mb-2" data-id="element-140">
              ARS 9.500
            </h3>
            <p className="text-sm md:text-base text-calm font-medium mb-6" data-id="element-141">
              Ahorrás ARS 35.500 hoy
            </p>
          </div>

          <CTAButton text="QUIERO QUE MI CUERPO APRENDA A SOLTAR" className="w-full md:w-auto md:px-12 md:py-6 text-lg" data-id="element-142" />

          <p className="mt-6 text-sm text-muted flex items-center justify-center gap-2" data-id="element-143">
            <span className="w-2 h-2 rounded-full bg-urgent animate-pulse" data-id="element-144"></span>
            Cupos limitados disponibles a este precio
          </p>
        </motion.div>
      </div>
    </section>;
}